import { createRouter as _createRouter, createWebHistory, createMemoryHistory } from "vue-router"
import Home from "@/page/homedemo/index.vue"
import Test from "@/page/test/index.vue"
import { isDev, isProd } from "@/utils/tools.js"
import useUserDataStore from "@/store/userDataStore"
import useHomeDataStore from "@/store/homeDataStore"
import globalConfig, { ModuleOpenStateControl } from "@/config/config.js"

export const loginRoutes = []
export const noAuthenticationRoutes = ["create", "special-christmas-gift"]
import { removeVideoResult } from "@/components/videoResult/videoResult.js"
import constSeoMap from "@/config/constSeo.js"
export const isNoAuthenticatedToLogin = () => {
  const userDataStore = useUserDataStore()
  const regs = [...noAuthenticationRoutes, ...loginRoutes]
    .map((item) => item?.split("/").pop().toLocaleLowerCase())
    .join("|")
  if (
    (window.location.pathname == "/" ||
      !new RegExp(`(${regs})$`).test(
        window.location.pathname.split("/").pop().toLocaleLowerCase()
      )) &&
    !userDataStore.isLogin
  ) {
    return true
  }
  return false
}

const routes = [
  {
    path: "/:lang(zh-Hans|zh-Hant|ja|ko|fr|de|es|it|pt|ru)?",
    component: () => import("@/page/main/i18nbox.vue"), // 只做包裹
    children: [
      {
        path: "test",
        name: "test",
        component: Test,
      },
      {
        path: "createtest",
        name: "createtest",
        component: () => import("@/page/create/create.vue"),
      },
      // 宣传页
      {
        path: "about",
        name: "about",
        component: () => import("@/page/land/landing.vue"),
        meta: {
          title: "about",
          ssrOff: true,
        },
      },
      {
        path: `profile`,
        name: "profile",
        component: () => import("@/mobile/mine/mine.vue"),
        meta: { ssrOff: true },
      },
      {
        path: "disclaimer",
        name: "disclaimer",
        component: () => import("@/page/items/disclaimer.vue"),
        meta: { ssrOff: true },
      },
      {
        path: "video-detail",
        name: "videoDetail",
        component: () => import("@/page/video/videoDetail.vue"),
        meta: { ssrOff: true },
      },
      {
        path: "",
        name: "main",
        component: () => import("@/page/main/main.vue"),
        children: [
          ...(ModuleOpenStateControl.editor.opened
            ? [
                {
                  // 创作
                  path: `editor`,
                  name: "editor",
                  component: () => import("@/page/editor/editor.vue"),
                  meta: {
                    title: "editor",
                    titlekey: "common.nav_create_music",
                  },
                },
              ]
            : []),
          {
            path: "home",
            name: "home",
            component: () => import("@/page/discover/index.vue"),
            meta: {
              title: "home",
              titlekey: "common.nav_home",
              // keepAlive: true,
              scrollCustom: true,
            },
          },
          {
            path: `genre/:name/:id/:last_id?`,
            name: "GenreDetail",
            component: () => import("@/page/discover/genre.vue"),
            meta: {
              full: true,
              title: "",
            },
          },
          {
            path: "genre-detail",
            redirect: { path: "/home" },
            meta: { redirectStatus: 301 },
          },
          {
            // 创作
            path: `create`,
            name: "create",
            component: () => import("@/page/create/create.vue"),
            meta: {
              title: "create",
              titlekey: "common.nav_create_music",
            },
          },
          {
            // 天空工坊
            path: ``,
            name: "createIndex",
            component: () => import("@/page/create/create.vue"),
            meta: {
              title: "create",
              titlekey: "common.nav_create_music",
            },
          },
          {
            // 创作
            path: `instrumental`,
            name: "instrumental",
            component: () => import("@/page/instrumental/create.vue"),
            meta: {
              title: "instrumental",
              titlekey: "common.nav_create_music",
            },
          },
          {
            path: "song-detail/:song_id",
            name: "songDetail",
            component: () => import("@/page/home/detailNew.vue"),
            meta: {
              // title: "store",
              titlekey: "common.nav_detail",
              skipNext: true,
              scrollCustom: true,
              // ssrOff: true,
            },
          },
          ...(!(globalConfig.appname == "MurekaCn" && isProd())
            ? [
                {
                  // tts
                  path: `speech/create`,
                  name: "speech",
                  component: () => import("@/page/tts/index.vue"),
                  meta: {
                    title: "speech",
                    // scrollCustom: true,
                  },
                },
              ]
            : []),
          {
            // 商详
            path: `song-detail`,
            name: "songDetailOld",
            component: () => import("@/page/home/detailNew.vue"),
            meta: {
              titlekey: "common.nav_detail",
              skipNext: true,
              scrollCustom: true,
              ssrOff: true,
            },
          },
          {
            // 天空工坊
            path: `subscribe`,
            name: "subscribe",
            component: () => import("@/page/credits/credits.vue"),
            meta: {
              // full: true,
              title: "subscribe",
              titlekey: "common.nav_credits",
              scrollCustom: true,
              // ssrOff: true,
            },
          },
          {
            // 收藏
            path: `library`,
            name: "library",
            component: () => import("@/page/library/library.vue"),
            meta: {
              title: "library",
              titlekey: "common.nav_library",
              scrollCustom: true,
              // keepAlive: true,
              ssrOff: true,
            },
          },
          {
            // 喜欢的
            path: `liked`,
            name: "liked",
            component: () => import("@/page/library/liked.vue"),
            meta: {
              // full: true,
              title: "library",
              titlekey: "common.nav_library",
              // keepAlive: true,
              ssrOff: true,
            },
          },
        ],
      },
      {
        path: `reset-password`,
        name: "resetPassword",
        component: () => import("@/page/login/resetPassword.vue"),
        meta: {
          title: "",
          ssrOff: true,
        },
      },
      {
        path: `payment-result`,
        name: "paymetResult",
        component: () => import("@/page/payment/pay_result.vue"),
        meta: {
          title: "",
          ssrOff: true,
        },
      },
      {
        path: `privacy`,
        name: "privacy",
        component: () => import("@/page/privacy.vue"),
        // $$language() == "en"
        //   ? () => import("@/page/privacy.vue")
        //   : () => import("@/page/privacyCn.vue"),
        meta: {
          title: "",
          ssrOff: true,
        },
      },
      {
        path: `terms`,
        name: "terms",
        component: () => import("@/page/terms/terms.vue"),
        meta: {
          title: "",
          ssrOff: true,
        },
      },
      {
        path: `release`,
        name: "release",
        component: () => import("@/page/release.vue"),
        meta: {
          title: "",
          ssrOff: true,
        },
      },
      // 移动端各人中心
      {
        path: `paid-service`,
        name: "paidService",
        component: () => import("@/page/paidService.vue"),
        meta: {
          title: "",
          ssrOff: true,
        },
      },
      {
        path: `payment`,
        name: "payment",
        component: () => import("@/page/payment/index.vue"),
        meta: {
          title: "",
          ssrOff: true,
        },
      },
      {
        path: `payment-cn-result`,
        name: "paymetCnResult",
        component: () => import("@/page/payment/pay_result_cn.vue"),
        meta: {
          title: "",
          ssrOff: true,
        },
      },
      {
        path: `oceanpay-doc`,
        name: "oceanpay-doc",
        component: () => import("@/page/credits/oceanpay.vue"),
        meta: {
          title: "",
          ssrOff: true,
        },
      },
    ],
  },
]

export function createRouter() {
  return _createRouter({
    history: import.meta.env.SSR ? createMemoryHistory() : createWebHistory(),
    routes,
    sensitive: true,
  })
}

export default createRouter()
